import React, { useRef, useEffect } from 'react'
import ServicesStyle from './ServicesStyle'
import ServiceCard from './ServiceCard'
import controller from '../../images/icons/controller.svg'
import binary from '../../images/icons/binary.svg'
import knight from '../../images/icons/knight.svg'
import film from '../../images/icons/film.svg'

//scroll sections

const Services = () => {
  // const [scrolled, setScrolled] = useState(false)

  const containerRef = useRef(null)

  useEffect(() => {
    const container = containerRef.current
    let lastScrollPosition = container.scrollLeft

    const handleScroll = () => {
      const currentScrollPosition = container.scrollLeft
      const scrolledMoreThan5px =
        Math.abs(currentScrollPosition - lastScrollPosition) > 5

      if (scrolledMoreThan5px) {
        // Logic to handle scroll more than 5px goes here
        // setScrolled(true)
      }

      lastScrollPosition = currentScrollPosition
    }

    container.addEventListener('scroll', handleScroll)

    return () => {
      container.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <ServicesStyle>
      <div className="scroll-section" ref={containerRef}>
        <ServiceCard
          icon={controller}
          header="Video Games"
          text="Retro style NES games, Unity games & experiences."
        />
        <ServiceCard
          icon={film}
          header="Film Digitization"
          text="Making old film and DVDs into accessible formats. Watch your old home videos on your computer our your very own streaming service."
        />
        <ServiceCard
          icon={binary}
          header="Custom Web Projects"
          text="Websites, apps, digital scavenger hunts & escape rooms."
        />
      </div>
    </ServicesStyle>
  )
}

export default Services
